module.exports = __webpack_public_path__ + "img/product-development.bd3f47ff.svg";